interface activityData{
    item: string;
    row: string;
    monthUnLimit: string;
    monthLimit: string;
    monthSum: string;
    yearUnLimit: string;
    yearLimit: string;
    yearSum: string;
    fomularDetail: string;
}

let list = [
    {
        item: "一、收 入",
        row: "",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: ""
    },
    {
        item: "　其中：捐赠收入",
        row: "1",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "捐赠收入"
    },
    {
        item: "　　　会费收入",
        row: "2",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "会费收入"
    },
    {
        item: "　　　提供服务收入",
        row: "3",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "提供服务收入"
    },
    {
        item: "　　　商品销售收入",
        row: "4",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "商品销售收入"
    },
    {
        item: "　　　政府补助收入",
        row: "5",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "政府补助收入"
    },
    {
        item: "　　　投资收益",
        row: "6",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "投资收益"
    },
    {
        item: "　　　其他收入",
        row: "9",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "其他收入"
    },
    {
        item: "　收入合计",
        row: "11",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "行1+行2+行3+行4+行5+行6+行9"
    },
    {
        item: "二、费 用",
        row: "",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: ""
    },
    {
        item: "（一）业务活动成本",
        row: "12",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "业务活动成本"
    },
    {
        item: "（二）管理费用",
        row: "21",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "（二）管理费用"
    },
    {
        item: "（三）筹资费用",
        row: "24",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "筹资费用"
    },
    {
        item: "（四）其他费用",
        row: "28",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "其他费用"
    },
    {
        item: "　费用合计",
        row: "35",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "行12+行21+行24+行28"
    },
    {
        item: "三、限定性净资产转为非限定性净资产",
        row: "40",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: ""
    },
    {
        item: "四、净资产变动额（若为净资产减少额，以“-”号填列）",
        row: "45",
        monthUnLimit: "0",
        monthLimit: "0",
        monthSum: "0",
        yearUnLimit: "0",
        yearLimit: "0",
        yearSum: "0",
        fomularDetail: "行11-行35+行40"
    }
]


let activityData = {
    list: list,
}
export default activityData